import { Reducer } from 'redux';
import { IModule } from 'redux-dynamic-modules';

import { ConfigurationState } from './ConfigurationState';
import { ConfigurationReducer } from './reducer';

export const getConfigurationModule: () => IModule<{
  Configuration: ConfigurationState;
}> = () => ({
  id: 'Configuration',
  reducerMap: {
    Configuration: ConfigurationReducer as Reducer,
  },
  middlewares: [],
});
